import { UserCircleIcon } from "lucide-react"

import { LoanOfficer } from "../../../../../types"
import { Badge } from "../../../../ui"
import ImageWrapper from "../../../img-wrapper"
import RoundedImg from "../../../rounded-img"
import { useCallback } from "react"

type Props = {
  info: LoanOfficer
  masqueradeEnabled: boolean
  onMasquerade: (loid: string) => void
  onUserCellClick?: (loID: string) => void
}

const UserCell = ({
  info,
  masqueradeEnabled,
  onMasquerade,
  onUserCellClick
}: Props) => {
  const {
    brand_admin,
    picture,
    email,
    position,
    loid = "",
    name,
    first_name,
    last_name
  } = info

  const handleUserCellClick = useCallback(() => {
    onUserCellClick?.(loid)
  }, [loid, onUserCellClick])

  const handleMasquerade = useCallback(
    (e: React.MouseEvent<SVGSVGElement>) => {
      e.stopPropagation()
      e.preventDefault()
      onMasquerade(loid)
    },
    [loid, onMasquerade]
  )

  return (
    <td
      className="whitespace-normal lg:whitespace-nowrap py-4 pl-2 pr-3 cursor-pointer max-w-xs"
      onClick={handleUserCellClick}
      colSpan={2}
    >
      <div className="flex group">
        <ImageWrapper
          isInitials
          initials={`${first_name[0] ?? ""} ${last_name[0] ?? ""}`}
        >
          <RoundedImg
            size={12}
            className="min-w-[3rem] hidden md:table-cell"
            src={picture}
            alt={`${name} thumbnail`}
          />
        </ImageWrapper>
        <div className="pl-0 md:pl-4">
          <div className="flex items-center">
            <strong className="text-base mr-2">
              {name?.trim().substring(0, 30) ?? "Unnamed"}
            </strong>
            {brand_admin ? <Badge.Success>Admin</Badge.Success> : ""}
            {masqueradeEnabled && (
              <UserCircleIcon
                size={20}
                className="mt-px text-gray-400 hidden md:group-hover:inline"
                onClick={handleMasquerade}
              />
            )}
          </div>
          <div className="text-sm text-neutral-500 whitespace-normal flex items-center gap-1 md:gap-1.5">
            {position}
            <span>●</span> LOID: {loid}
          </div>
          <div className="text-sm text-neutral-500 md:hidden">{email}</div>
        </div>
      </div>
    </td>
  )
}

export default UserCell
